import React, { useState } from "react";
import { BankGlPreset } from "../../domain/entities/BankGlPickerEntity";
import { GLMappingEntity } from "../../domain/entities/GLMappingEntity";
import { useBankGlTree } from "../hooks/useBankGlTree";
import { GlTreePickerShell } from "./GlTreePickerShell";

export interface BankGlAccountDropdownProps {
  preset: BankGlPreset;
  bankAccountId?: string;
  selectedAccountId?: string;
  selectedAccountName?: string;
  onSelect: (account: GLMappingEntity) => void;
  disabled?: boolean;
  className?: string;
  dropdownClassName?: string;
  placeholder?: string;
  buttonClassName?: string;
}

export function BankGlAccountDropdown({
  preset,
  bankAccountId,
  selectedAccountId,
  selectedAccountName,
  onSelect,
  disabled = false,
  className = "",
  dropdownClassName = "",
  placeholder = "Select an account",
  buttonClassName = "",
}: BankGlAccountDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  const treeState = useBankGlTree({
    preset,
    bankAccountId,
    selectedAccountId,
    enabled: isOpen && !disabled,
  });

  return (
    <GlTreePickerShell
      treeState={treeState}
      selectedAccountId={selectedAccountId}
      selectedAccountName={selectedAccountName}
      onSelect={onSelect}
      disabled={disabled}
      className={className}
      dropdownClassName={dropdownClassName}
      placeholder={placeholder}
      buttonClassName={buttonClassName}
      onOpenChange={setIsOpen}
    />
  );
}

export default BankGlAccountDropdown;
